/*eslint-disable*/
import React from "react";
// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// core components
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";
import {Dictionary} from "../../database/dictionary";
import {Hidden} from "@material-ui/core";

function HeaderLinks({...props}) {
    const {classes} = props;
    return (
        <List className={classes.list}>
            <ListItem className={classes.listItem}>

                <Button
                    href="/projects"
                    color="transparent"
                    className={classes.navLink}
                >
                    Projects
                </Button>
            </ListItem>
            <ListItem className={classes.listItem}>

                <Button
                    href="/speaker"
                    color="transparent"
                    className={classes.navLink}
                >
                    Speaking
                </Button>
            </ListItem>
            <ListItem className={classes.listItem}>

                <Button
                    href="https://vrational.com/"
                    color="transparent"
                    target="_blank"
                    className={classes.navLink}
                >
                    Blog
                </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
                <Button
                    href={Dictionary.twitter}
                    target="_blank"
                    color="transparent"
                    className={classes.navLink}
                >
                    <i className={classes.socialIcons + " fab fa-twitter"}/> <Hidden mdUp>Twitter</Hidden>
                </Button>
            </ListItem>
            <ListItem className={classes.listItem}>
                <Button
                    color="transparent"
                    href={Dictionary.linkedin}
                    target="_blank"
                    className={classes.navLink}
                >
                    <i className={classes.socialIcons + " fab fa-linkedin"}/> <Hidden mdUp>LinkedIn</Hidden>
                </Button>
            </ListItem>
            <ListItem className={classes.listItem}>

                <Button
                    color="transparent"
                    href={Dictionary.instagram}
                    target="_blank"
                    className={classes.navLink}
                >
                    <i className={classes.socialIcons + " fab fa-instagram"}/> <Hidden mdUp>Instagram</Hidden>
                </Button>
            </ListItem>
        </List>
    );
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/views/LandingPage/HeaderLinks.jsx